export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const REQUEST_FORGOT_PASSWORD = 'REQUEST_FORGOT_PASSWORD';

export const loginSuccess = (data: any) => ({
  type: LOGIN_SUCCESS,
  payload: data,
});

export const logout = () => ({
  type: LOGOUT,
});

export const updateProfile = (profileData: any) => ({
  type: UPDATE_PROFILE,
  payload: profileData,
});

export const requestForgotPassword = (sessionId: string, email: string) => ({
  type: REQUEST_FORGOT_PASSWORD,
  payload: { sessionId, email },
});
